import React, {useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import {ShopContainerContext} from "../containers/ShopContainer";
import {Image} from "antd";


export const renderManagedProduct = ({translate: t, renderActions = NullAsDefault, renderContextMenu = NullAsDefault, statusFilter} = {}) => (item, index) => {
    const {
        onSelectShopContainerRoute
    } = useContext(ShopContainerContext);

    const {
        avatar,
        product_variants = [],
        price_unit,
        about_html,
        product_type,
    } = item ?? {}

    const price_unit_label = price_unit?.short_name || 'VND'

    return (
        <div
            className="border-t border-color-50 shadow hover:shadow-md hover:scale-2xs rounded-lg flex flex-col items-center custom-item-render relative">
            <Image
                preview={false}
                src={avatar}
                style={{height: 180}}
                wrapperClassName="rounded-t-lg rounded-b-0 object-cover"
            />
            <div className="p-3 w-full flex flex-col flex-1">
                <span className="mb-1 font-semibold text-indigo-600 tracking-wide leading-snug">
                    {product_type}
                </span>
                <div
                    onClick={() => {onSelectShopContainerRoute({current_product_id: item.id})}}
                    className="font-bold text-base text-color-000 hover:text-primary tracking-wide cursor-pointer max-lines-2">
                    {item?.title}
                </div>
                {item?.author_name && (
                    <div className="space-x-1 text-sm leading-snug">
                        <span className="text-sm text-color-300 tracking-wider">
                            {`${t('author')}: `}
                        </span>
                        <span className="font-medium text-indigo-500 italic tracking-wide">
                            {item?.author_name}
                        </span>
                    </div>
                )}
                <div className="max-lines-4 overflow-hidden">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: about_html
                        }}
                        className="prose ml-5 my-2 text-color-300 text-xs text-color-300 tracking-wider"
                    />
                </div>
                <div className="mt-auto flex flex-col items-end">
                    <span className="text-sm text-color-300 tracking-wider">
                        {t('price')}
                    </span>
                    <div className="flex items-baseline gap-1">
                        {product_variants[0]?.compare_price ? (
                            <div className="text-xs text-color-500 italic leading-snug tracking-wider line-through">
                                {(product_variants[0]?.compare_price)?.toLocaleString()}
                            </div>
                        ) : ''}
                        <div className="font-bold text-primary leading-snug tracking-wider">
                            {(product_variants[0]?.price)?.toLocaleString()} {price_unit_label}
                        </div>
                    </div>
                </div>
            </div>

            <div className="absolute top-5 right-5 flex gap-3 flex-row">
                <div className="contextIcon">
                    {renderContextMenu(item)}
                </div>
            </div>
        </div>
    )
}
